module.exports = __webpack_public_path__ + "img/carrousel-mamo-6.2dce1c2e.jpg";